module.exports = __webpack_public_path__ + "static/media/dem_met_sta.59e0ffdc.png";